const { historyBack } = require('./history-back')
const { historyClearForward } = require('./history-clear-forward')
const { historyPush } = require('./history-push')
const { historyReplace } = require('./history-replace')

module.exports = {
  historyBack,
  historyClearForward,
  historyPush,
  historyReplace
}
